import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "saas-agreement-modal",
  templateUrl: "view-file.component.html",
  styleUrls: ["./view-file.component.scss"],
})
export class ViewModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer
  ) {}

  getUrl() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      this.data.SasAgreementFileUrl
    );
  }
}
